module.exports = __webpack_public_path__ + "img/black-stickers.bc57f1c1.png";